// extracted by mini-css-extract-plugin
module.exports = {"orange-text-shadow":"styles_orange-text-shadow__1vUJu"};